export default __webpack_public_path__ + "static/media/pic_4.b18b9bac.webp";